var React = require('react');

function LeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.753.565l.494.87C3.353 12.18-2.638 30.31 4.273 55.95l.214.78 1.816 5.775 1.5-7.113.978.206-1.892 8.982-.183.87-.648-.608-6.694-6.281.685-.73 5.301 4.975-1.822-5.793C-3.836 30.531 2.238 11.665 21.753.565z","fill":"#97979D"}));
}

LeftInline.defaultProps = {"width":"24","height":"66"};

module.exports = LeftInline;

LeftInline.default = LeftInline;
